/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

function initOwlSlider() {
    var owlDanbro = jQuery("#owl-danbro");

    owlDanbro.owlCarousel({
        autoplay: true,
        loop: true,
        autoplayTimeout: 5000,
        items: 6,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [979, 3],
//        navigation: true,
        navigationText: false,
    });

    jQuery(".owl-next").click(function () {
        jQuery("#owl-danbro").trigger('owl.prev');
    });

    jQuery(".owl-previous").click(function () {
        jQuery("#owl-danbro").trigger('owl.next');
    });
}

/* This function sets the appropriate form action
   It depends on the usernames being prefixed with an identifier.
   For the case of scs, it's scs and for the generic system it's dci.
   Any time the login field is changed, it runs the function.
*/
function initFormSwitcher(codeFieldId) {
    console.log("start");

    codeFieldIdHash = '#' + codeFieldId;
    loginFormId = 'dci-buyer-login';

    var loginForm = document.getElementById(loginFormId);

    jQuery(codeFieldIdHash).change(function() {
        var accessCode = jQuery(codeFieldIdHash).val();
        var result = accessCode.split('-');
        usernamePrefix = result[0];

        if (usernamePrefix == 'scs') {
            loginForm.action = 'http://scs.orders.durhamcityinteriors.com/buying-platform-login/login.php'
        } else if (usernamePrefix == 'dci') {
            loginForm.action = 'http://standard.orders.durhamcityinteriors.com/buying-platform-login/login.php'
        }
    });
}

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        jQuery("img.lazy").lazyload();
      }
    },
    // Home page
    'home': {
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        jQuery('.single-wrapper > p').matchHeight();
        jQuery('.single-wrapper > h2').matchHeight();
      }
    },
    // About us page, note the change from about-us to about_us.
    'workwear': {
      init: function() {
          initOwlSlider();
      }
  },
  // About us page, note the change from about-us to about_us.
  'ppe': {
    init: function() {
        initOwlSlider();
    }
  },
  // About us page, note the change from about-us to about_us.
  'bespoke_buying_platform': {
    finalize: function() {
        initFormSwitcher('dci-buyer-login-code');
    }
  }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
